import { call, put, takeLatest } from "redux-saga/effects";
import { meActions } from "./meSlice";
import meApi from "api/meApi";
import { toast } from "react-toastify";
import { ApiResponse } from "models";

function* fetchMeData() {
  try {
    const response: ApiResponse = yield call(meApi.getMyProfile);
    const data = response?.data;
    if (response.success && data) {
      yield put(meActions.getMeSuccess(data as any));
    } else {
      yield put(meActions.getMeFailed(response.message || "Failed to fetch profile"));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(meActions.getMeFailed(errorData?.message || "Failed to fetch profile"));
  }
}

export function* meSaga() {
  yield takeLatest(meActions.getMeRequest.type, fetchMeData);
}
